import BaseService from "@utils/BaseService";
import axios from '@plugins/axios';

class TipoJuegoService extends BaseService {
    get(id, options = {}) {
        return axios({
            url: this.getRoute(id),
            method: 'GET',
            ...options
        });
    }
    getList(filters = {}, options = {}) {
        return axios({
            url: this.getRoute(),
            method: 'GET',
            params: this.getParamsProcessed({is_active: true, ...filters}),
            ...options
        });
    }
    count(filters = {}, options = {}) {
        return axios({
            url: this.getRoute(),
            method: 'GET',
            params: this.getParamsProcessed({is_active: true, ...filters}),
            ...options
        });
    }
}

export const BaseTipoJuegoService = TipoJuegoService;

export default new TipoJuegoService({
    domainName:'loteria',
    entityName:'tipo-juego',
    query:['search', 'is_active'],
});